/* VORTIX · interacciones y animaciones */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- 1. barra de progreso de scroll ---------- */
  function progress() {
    var bar = $('.vx-prog');
    if (!bar) return;
    var raf = null;
    function paint() {
      raf = null;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.transform = 'scaleX(' + (h > 0 ? Math.min(window.scrollY / h, 1) : 0) + ')';
    }
    addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(paint); }, { passive: true });
    paint();
  }

  /* ---------- 2. header pegajoso ---------- */
  function header() {
    var hd = $('.vx-hd');
    if (!hd) return;
    function paint() { hd.classList.toggle('is-stuck', window.scrollY > 24); }
    addEventListener('scroll', paint, { passive: true });
    paint();
  }

  /* ---------- 3. reveals al hacer scroll ---------- */
  function reveals() {
    var els = $$('.vx-rv');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- 4. contadores animados ---------- */
  function counters() {
    var els = $$('[data-count]');
    if (!els.length) return;

    function fmt(n, dec) {
      return n.toLocaleString('es-ES', { minimumFractionDigits: dec, maximumFractionDigits: dec });
    }
    function run(el) {
      var target = parseFloat(el.getAttribute('data-count'));
      var dec = parseInt(el.getAttribute('data-dec') || '0', 10);
      if (reduce) { el.textContent = fmt(target, dec); return; }
      var dur = 1500, t0 = null;
      function frame(t) {
        if (t0 === null) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var e = 1 - Math.pow(1 - p, 3);           // easeOutCubic
        el.textContent = fmt(target * e, dec);
        if (p < 1) requestAnimationFrame(frame);
        else el.textContent = fmt(target, dec);
      }
      requestAnimationFrame(frame);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { run(en.target); io.unobserve(en.target); }
      });
    }, { threshold: 0.45 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- 5. acordeón FAQ ---------- */
  function faq() {
    $$('.vx-q').forEach(function (q) {
      var btn = $('.vx-q__t', q), body = $('.vx-q__b', q);
      if (!btn || !body) return;
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var open = q.classList.contains('is-open');
        // cierra las demás
        $$('.vx-q.is-open').forEach(function (o) {
          if (o === q) return;
          o.classList.remove('is-open');
          var ob = $('.vx-q__b', o), obt = $('.vx-q__t', o);
          if (ob) ob.style.maxHeight = '0px';
          if (obt) obt.setAttribute('aria-expanded', 'false');
        });
        q.classList.toggle('is-open', !open);
        btn.setAttribute('aria-expanded', String(!open));
        body.style.maxHeight = open ? '0px' : body.scrollHeight + 'px';
      });
    });
    addEventListener('resize', function () {
      $$('.vx-q.is-open .vx-q__b').forEach(function (b) { b.style.maxHeight = b.scrollHeight + 'px'; });
    });
  }

  /* ---------- 6. hotspots del mapa del coche ---------- */
  function hotspots() {
    var pins = $$('button[data-hot]');
    if (!pins.length) return;
    function show(key) {
      pins.forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-hot') === key); });
      $$('.vx-hot__item').forEach(function (i) { i.classList.toggle('is-on', i.getAttribute('data-hot') === key); });
    }
    pins.forEach(function (p) {
      p.addEventListener('click', function () { show(p.getAttribute('data-hot')); });
      p.addEventListener('mouseenter', function () { show(p.getAttribute('data-hot')); });
    });
    show(pins[0].getAttribute('data-hot'));
  }

  /* ---------- 7. barra de compra fija en móvil ---------- */
  function buybar() {
    var bar = $('.vx-bar');
    if (!bar) return;
    var anchor = $('.vx-hero') || $('.vx-pdp');
    function paint() {
      var y = anchor ? anchor.getBoundingClientRect().bottom : 600;
      bar.classList.toggle('is-on', y < 0);
    }
    addEventListener('scroll', paint, { passive: true });
    addEventListener('resize', paint);
    paint();
  }

  /* ---------- 8. galería de producto ---------- */
  function gallery() {
    var main = $('.vx-gal__main img');
    var thumbs = $$('.vx-gal__thumbs button');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-src');
        if (!src) return;
        main.style.opacity = '0';
        setTimeout(function () {
          main.src = src;
          var img = $('img', t);
          main.alt = img ? img.alt : '';
          main.style.opacity = '1';
        }, 150);
        thumbs.forEach(function (o) { o.classList.toggle('is-on', o === t); });
      });
    });
    main.style.transition = 'opacity .15s ease';
  }

  /* ---------- 9. marquee sin costuras ---------- */
  function ticker() {
    $$('.vx-tick__run').forEach(function (run) {
      var g = $('.vx-tick__g', run);
      if (g && run.children.length === 1) run.appendChild(g.cloneNode(true));
    });
  }

  /* ---------- 10. precio en vivo al cambiar de pack ---------- */
  function variants() {
    var form = $('[data-vx-form]');
    if (!form) return;
    var radios = $$('input[name="id"]', form);
    if (!radios.length) return;
    function paint() {
      var r = radios.filter(function (x) { return x.checked; })[0];
      if (!r) return;
      var price = r.getAttribute('data-price'), was = r.getAttribute('data-was');
      $$('[data-vx-live-price]').forEach(function (e) { e.textContent = price || ''; });
      $$('[data-vx-live-was]').forEach(function (e) { e.textContent = was || ''; });
    }
    radios.forEach(function (r) { r.addEventListener('change', paint); });
    paint();
  }

  function init() {
    progress(); header(); ticker(); reveals(); counters();
    faq(); hotspots(); buybar(); gallery(); variants();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
